/* eslint-disable max-lines */
/* eslint-disable max-statements */
/* eslint-disable id-length */
/* eslint-disable no-unused-vars */
/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable react/no-multi-comp */
/* eslint-disable sort-keys */
/* eslint-disable global-require */
/* eslint-disable complexity */
/* eslint-disable react/jsx-no-target-blank */
import React, { useEffect, useState } from 'react'
import CardApp from './components/CardApp'
import CardIndicate from './components/CardIndicate'
import CardAssinatura from './components/CardAssinatura'
import CardAssineClube from './components/CardAssineClube'
import CardOpcionais from '../../containers/Opcionais/CardOpcionais'
import CardPresenteado from './components/CardPresenteado'
import CardVideo from '../../components/CardVideo/CardVideo'
import styled from 'styled-components'
import { useGlobal } from '../../contexts/GlobalContext'
import { OpcionaisProvider } from '../../contexts/OpcionaisContext'
import ComboRenovacaoModal from './components/RenovacaoModal/ComboRenovacaoModal'
import { CartaoCreditoProvider } from '../../contexts/CartaoCreditoContext'
import StyleGuide from '@taglivros/oef_componentes/build/components/styleGuide'
import { navigate } from '@reach/router'
import { URLS_APP } from '../../config'
import { STATUS_VALIDOS_ASSINATURAS_OPCIONAIS } from '../../containers/Opcionais/constantsCardOpcionais'

import {
  MODALIDADE_CURADORIA,
  MODALIDADE_INEDITOS,
  ROUTE_BASEPATH,
  URLS,
  EVENTOS_GA,
  STATUS_CANCELADO,
} from '../../constants'
import { objetoTemPropriedade, isEmptyObject } from '../../utils/helpers/helpers'
import { TEXTOS_ONBOARDING, URL_VIDEO_ONBOARDING } from './constantsHome'
import { enviaEventoGA } from '../../utils/helpers/helpersGA'
import { getInformacoesModalidadePorAssinatura } from '../../utils/helpers/helpersAssinatura'
import { resolverCategorias, temAssinaturaClubeNormal, temBookster } from '../../utils/helpers/helpersToken'
import { navigateParaBookster } from '../../utils/rotas/navigate'

const { isMobile } = StyleGuide

const H1 = styled.h1`
  font-size: 24px;
  color: #1b2a68;
  @media (max-width: ${StyleGuide.mediaQuery.mobile}) {
    font-size: 18px;
  }
`

const CardAppMobile = styled.div`
  @media (max-width: 500px) {
    display: unset;
  }
  @media (min-width: 501px) {
    display: none;
  }
`

const CardAppDesktop = styled.div`
  @media (max-width: 500px) {
    display: none;
  }
  @media (min-width: 501px) {
    display: unset;
  }
`

const ConteudoWrapper = styled.div`
  display: flex;
  gap: 30px;
  @media (max-width: 600px) {
    gap: 10px;
  }
  @media (max-width: ${StyleGuide.mediaQuery.mobile}) {
    flex-direction: column;
    margin: 0;
  }
`

const LeftContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: calc(100vw - 50px);
  @media (min-width: 521px) {
    width: calc(100vw / 2 - 30px);
  }
  @media (min-width: 770px) {
    width: calc(100vw / 2.5 - 50px);
  }
`

const RightContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;

  width: calc(100vw - 50px);
  @media (min-width: 521px) {
    width: calc(100vw / 2 - 30px);
  }
  @media (min-width: 770px) {
    width: calc(100vw / 2.5 - 50px);
  }
`

const RightContentTitleSpacement = styled.div`
  height: 28px;
`

const OpcionaisWrapper = styled.div`
  max-width: 1090px;
  text-align: left;
`

const CardOnboardingWrapper = styled.div`
  max-width: 1090px;
  text-align: left;
  width: calc(100% - 5%);
  margin: 20px 0;

  @media (max-width: ${StyleGuide.mediaQuery.tablet}) {
    margin: 20px auto;
  }

  @media (max-width: ${StyleGuide.mediaQuery.mobile}) {
    margin: 20px auto 0;
  }
`

const Banner = styled.img`
  height: auto;
  max-width: 100%;
  border-radius: 10px;
  margin: 15px 0;

  @media (max-width: ${StyleGuide.mediaQuery.mobile}) {
    max-width: 100%;
  }
`

const Home = () => {
  const {
    shouldShowSetupUserData,
    shouldShowSetupSubscriptionSelect,
    dadosGlobaisAssociado,
    getDadosStrapi,
    dadosStrapi,
    getRedirectToParameter,
    getCouponParameter,
  } = useGlobal()
  const [ assinaturaCuradoria, setAssinaturaCuradoria ] = useState()
  const [ assinaturaIneditos, setAssinaturaIneditos ] = useState()
  const [ modalidadeCuradoria, setModalidadeCuradoria ] = useState()
  const [ modalidadeIneditos, setModalidadeIneditos ] = useState()
  const [ curadoriaPodeRenovar, setCuradoriaPodeRenovar ] = useState( false )
  const [ ineditosPodeRenovar, setIneditosPodeRenovar ] = useState( false )
  const [ loading, setLoading ] = useState( true )
  const [ comboRenovacaoModal, setComboRenovacaoModal ] = useState( false )

  useEffect( () => {
    let cancelado = false

    const verificarBooksterExclusivo = async() => {
      const categorias = await resolverCategorias()
      if ( !cancelado && temBookster( categorias ) ) {
        navigateParaBookster()
      }
    }

    if ( !temAssinaturaClubeNormal() ) {
      verificarBooksterExclusivo()
    }

    return () => {
      cancelado = true
    }
  }, [] )

  const hasUmaAssinatura = assinaturaIneditos || assinaturaCuradoria
  const hasDuasAssinaturas = assinaturaIneditos && assinaturaCuradoria
  const assinaturaCuradoriaPresente =
    assinaturaCuradoria &&
    objetoTemPropriedade( assinaturaCuradoria, 'controles' ) &&
    assinaturaCuradoria.controles.isPresente
  const assinaturaIneditosPresente =
    assinaturaIneditos &&
    objetoTemPropriedade( assinaturaIneditos, 'controles' ) &&
    assinaturaIneditos.controles.isPresente
  const temAssinaturaCuradoriaCancelada = assinaturaCuradoria && assinaturaCuradoria.status === STATUS_CANCELADO
  const temAssinaturaIneditosCancelada = assinaturaIneditos && assinaturaIneditos.status === STATUS_CANCELADO
  const hasAssinaturasAtivas = dadosGlobaisAssociado && dadosGlobaisAssociado.assinaturas.some( assinatura => STATUS_VALIDOS_ASSINATURAS_OPCIONAIS.includes( assinatura.status ) )

  const banners = dadosStrapi?.data[ 0 ]?.Banners

  useEffect( () => {
    if (
      dadosGlobaisAssociado &&
      objetoTemPropriedade( dadosGlobaisAssociado, 'assinaturas' )
    ) {
      getDadosStrapi()
      const curadoria = dadosGlobaisAssociado.assinaturas.find( assinatura => assinatura.modalidade === MODALIDADE_CURADORIA.visualizacao )
      const ineditos = dadosGlobaisAssociado.assinaturas.find( assinatura => assinatura.modalidade === MODALIDADE_INEDITOS.visualizacao )
      if ( curadoria ) {
        setAssinaturaCuradoria( curadoria )
        setCuradoriaPodeRenovar( curadoria.controles.podeRenovar &&
          !curadoria.modalidade.temCobrancaBoletoPendente?.temCobrancaBoletoPendente &&
          !curadoria.modalidade.temCobrancaPixPendente?.temCobrancaPixPendente )
      }

      if ( ineditos ) {
        setAssinaturaIneditos( ineditos )
        setIneditosPodeRenovar( ineditos.controles.podeRenovar &&
          !ineditos.modalidade.temCobrancaBoletoPendente?.temCobrancaBoletoPendente &&
          !ineditos.modalidade.temCobrancaPixPendente?.temCobrancaPixPendente )
      }

      const controleModalidades = [
        [ MODALIDADE_CURADORIA.id, setModalidadeCuradoria ],
        [ MODALIDADE_INEDITOS.id, setModalidadeIneditos ]
      ]

      for ( const [ modalidadeId, modalidadeSetter ] of controleModalidades ) {
        const modalidade = dadosGlobaisAssociado.modalidades.find( ( { id } ) => id === modalidadeId )
        if ( modalidade ) {
          modalidadeSetter( modalidade )
        }
      }

      const redirectTo = getRedirectToParameter()
      getCouponParameter()
      if ( redirectTo ) {
        navigate( redirectTo )
      }
    }
  }, [ dadosGlobaisAssociado ] )

  useEffect( () => {
    if ( shouldShowSetupUserData === true && shouldShowSetupSubscriptionSelect === false ) {
      navigate( ROUTE_BASEPATH !== `/` ? `${ROUTE_BASEPATH}/${URLS.SETUP_ASSINATURA}` : `${URLS.SETUP_ASSINATURA}`, { 'replace': true } )
    } else if ( shouldShowSetupSubscriptionSelect === true && shouldShowSetupUserData === false ) {
      navigate( ROUTE_BASEPATH !== `/` ? `${ROUTE_BASEPATH}/${URLS.SETUP_ASSINATURA_ESCOLHA_CLUBE}` : `${URLS.SETUP_ASSINATURA_ESCOLHA_CLUBE}`, { 'replace': true } )
    }
  }, [ shouldShowSetupUserData, shouldShowSetupSubscriptionSelect ] )

  useEffect( () => {
    setLoading( false )
  }, [] )

  const cardSegundaAssinatura = () => {
    if ( assinaturaCuradoria ) {
      return (
        <CardAssineClube
          idParaAssinar={ MODALIDADE_INEDITOS.id }
          slugModalidadeAssinada={ MODALIDADE_CURADORIA.slug }
          temCobrancaBoletoPendente={
            modalidadeIneditos.temCobrancaBoletoPendente
          }
          temCobrancaPixPendente={
            modalidadeIneditos.temCobrancaPixPendente
          }
        />
      )
    } else if ( assinaturaIneditos ) {
      return (
        <CardAssineClube
          idParaAssinar={ MODALIDADE_CURADORIA.id }
          slugModalidadeAssinada={ MODALIDADE_INEDITOS.slug }
          temCobrancaBoletoPendente={
            modalidadeCuradoria.temCobrancaBoletoPendente
          }
          temCobrancaPixPendente={
            modalidadeCuradoria.temCobrancaPixPendente
          }
        />
      )
    }
  }

  const prefixo = isMobile() ? 'mobile' : 'desktop'

  const getWorkflowName = ( workflowPrefixo, testeCuradoria, testeIneditos ) => {
    if ( testeCuradoria || testeIneditos ) {
      if ( testeCuradoria && testeIneditos ) {
        return `${workflowPrefixo}_combo`
      } else if ( testeCuradoria ) {
        return `${workflowPrefixo}_curadoria`
      } else if ( testeIneditos ) {
        return `${workflowPrefixo}_ineditos`
      }
    }
    return null
  }

  const getWorkflowHref = ( banner, fallbackUrlPath, testeCuradoria, testeIneditos ) => {
    if ( testeCuradoria && testeIneditos ) {
      return null
    }
    if ( banner.linkTo ) {
      return banner.linkTo
    }
    const assinatura = testeCuradoria
      ? assinaturaCuradoria
      : assinaturaIneditos
    const { modalidade } = assinatura
    const { 'slug': modalidadeSlug } = getInformacoesModalidadePorAssinatura( modalidade )
    const fallbackUrl = `${ROUTE_BASEPATH}${URLS_APP.BASE_PATH ? '/' : ''}${modalidadeSlug}/${URLS.PLANO}/${fallbackUrlPath}`
    return fallbackUrl
  }

  const getWorkflowBanner = () => {
    if ( !banners ) {
      return null
    }
    const workflowReativacao = getWorkflowName( 'reativacao', temAssinaturaCuradoriaCancelada, temAssinaturaIneditosCancelada )
    const workflowRenovacao = getWorkflowName( 'renovacao', curadoriaPodeRenovar, ineditosPodeRenovar )
    const workflow = workflowRenovacao || workflowReativacao
    let banner = null
    banner = banners.find( b => b.workflow === workflow )
    if ( !banner ) {
      const workflowOpcionais = getWorkflowName( 'opcionais', assinaturaCuradoria, assinaturaIneditos )
      banner = banners.find( b => b.workflow === workflowOpcionais )
    }
    if ( banner ) {
      let bannerHref = null
      if ( banner.workflow.includes( 'reativacao' ) ) {
        bannerHref = getWorkflowHref( banner, URLS.REATIVAR_ASSINATURA_ENTREGA, temAssinaturaCuradoriaCancelada, temAssinaturaIneditosCancelada )
      } else if ( banner.workflow.includes( 'renovacao' ) ) {
        bannerHref = getWorkflowHref( banner, URLS.RENOVAR_PLANO_ENTREGA, curadoriaPodeRenovar, ineditosPodeRenovar )
      }
      return {
        'workflow': banner.workflow,
        'title': banner.title,
        'alt': banner.caption,
        'src': banner[ `${prefixo}Image` ].url,
        'href': bannerHref,
        'scroll': banner.scrollTo,
        'gaEventCategory': banner.gaEventCategory,
        'gaEventAction': banner.gaEventAction,
      }
    }
    return null
  }

  function handleModalRenovacao( url ) {
    if ( url ) {
      return navigate( url )
    } else {
      setComboRenovacaoModal( true )
    }
  }

  function scrollTo( elementId ) {
    const id = elementId
    const yOffset = -50
    const element = document.getElementById( id )
    const y =
       element.getBoundingClientRect().top + window.pageYOffset + yOffset
    window.scrollTo( { 'top': y, 'behavior': 'smooth' } )
  }

  const podeMostrarOnboarding =
    !isEmptyObject( dadosGlobaisAssociado ) &&
    !dadosGlobaisAssociado.associado.dataUltimoAcessoAreaDoAssociado

  const workflowBanner = getWorkflowBanner()

  const LinkTo = () => {
    return (
      <a
        href={ workflowBanner.href || '#' }
        style={{ 'cursor': 'pointer' }}
        target="_blank"
      >
        <Banner
          alt={ workflowBanner.alt }
          src={ workflowBanner.src }
        />
      </a>
    )
  }

  const ScrollTo = () => {
    return (
      <div
        onClick={ () => {
          scrollTo( workflowBanner.scroll || '' )
          enviaEventoGA(
            workflowBanner.gaEventCategory,
            workflowBanner.gaEventAction
          )
        } }
        style={{ 'cursor': 'pointer' }}
      >
        <Banner
          alt={ workflowBanner.alt }
          src={ workflowBanner.src }
        />
      </div>
    )
  }

  return (
    <>
      {workflowBanner && ( workflowBanner.workflow.includes( 'renovacao' ) || workflowBanner.workflow.includes( 'reativacao' ) ) ?
        <div
          onClick={ () => {
            enviaEventoGA(
              workflowBanner.gaEventCategory,
              workflowBanner.gaEventAction
            )
            if ( workflowBanner.workflow.includes( 'renovacao' ) ) {
              handleModalRenovacao( workflowBanner.href )
            } else {
              navigate( workflowBanner.href )
            }
          } }
          style={{ 'cursor': 'pointer' }}
        >
          <Banner
            alt={ workflowBanner.alt }
            src={ workflowBanner.src }
          />
        </div> : null}

      {workflowBanner && !( workflowBanner.workflow.includes( 'renovacao' ) || workflowBanner.workflow.includes( 'reativacao' ) ) ?
        <div style={{ 'paddingTop': '20px' }}>
          {workflowBanner.title ?
            <H1>
              {workflowBanner.title}
            </H1> : null}

          { workflowBanner.href ? <LinkTo /> : <ScrollTo /> }
        </div> : null}

      {comboRenovacaoModal && curadoriaPodeRenovar && ineditosPodeRenovar ?
        <ComboRenovacaoModal
          curadoriaPodeRenovar={ curadoriaPodeRenovar }
          ineditosPodeRenovar={ ineditosPodeRenovar }
          onShowModal={ () => setComboRenovacaoModal( false ) }
          open={ comboRenovacaoModal }
        /> : null}

      {podeMostrarOnboarding ? (
        <CardOnboardingWrapper>
          <CardVideo
            onFinalizar={ () => enviaEventoGA(
              EVENTOS_GA.ONBOARDING.FLUXO,
              EVENTOS_GA.ONBOARDING.ACOES.TERMINOU
            ) }
            playAutomatico={ true }
            subtitulo={ TEXTOS_ONBOARDING.subtitulo }
            titulo={ TEXTOS_ONBOARDING.titulo }
            urlVideo={ URL_VIDEO_ONBOARDING }
          />
        </CardOnboardingWrapper>
      ) : null}

      {Boolean( dadosGlobaisAssociado ) &&
        !isEmptyObject( dadosGlobaisAssociado ) &&
        ( loading ? (
          <p>Carregando</p>
        ) : (
          <ConteudoWrapper>
            <OpcionaisProvider>
              <LeftContent>
                <H1>Minha assinatura</H1>

                {Boolean( assinaturaCuradoria ) && Boolean( assinaturaIneditos ) && (
                  <CartaoCreditoProvider>
                    <CardAssinatura
                      assinatura={ assinaturaCuradoria }
                      dadosGlobaisAssociado={ dadosGlobaisAssociado }
                      modalidade={ modalidadeCuradoria }
                      showEnvios={ true }
                      showSaibaMais={ false }
                      verMaisUrl={ `${ROUTE_BASEPATH}${
                        URLS_APP.BASE_PATH ? '/' : ''
                      }curadoria` }
                    />
                  </CartaoCreditoProvider>
                )}

                {Boolean( assinaturaCuradoria ) && Boolean( assinaturaIneditos ) && (
                  <CartaoCreditoProvider>
                    <CardAssinatura
                      assinatura={ assinaturaIneditos }
                      dadosGlobaisAssociado={ dadosGlobaisAssociado }
                      modalidade={ modalidadeIneditos }
                      showEnvios={ true }
                      showSaibaMais={ false }
                      verMaisUrl={ `${ROUTE_BASEPATH}${
                        URLS_APP.BASE_PATH ? '/' : ''
                      }ineditos` }
                    />
                  </CartaoCreditoProvider>
                )}

                {Boolean( hasUmaAssinatura ) && !hasDuasAssinaturas && (
                  <CartaoCreditoProvider>
                    <CardAssinatura
                      assinatura={
                        assinaturaCuradoria
                          ? assinaturaCuradoria
                          : assinaturaIneditos
                      }
                      dadosGlobaisAssociado={ dadosGlobaisAssociado }
                      modalidade={
                        assinaturaCuradoria
                          ? modalidadeCuradoria
                          : modalidadeIneditos
                      }
                      showEnvios={ true }
                      showSaibaMais={ false }
                      verMaisUrl={ `${ROUTE_BASEPATH}${
                        URLS_APP.BASE_PATH ? '/' : ''
                      }${assinaturaCuradoria ? 'curadoria' : 'ineditos'}` }
                    />
                  </CartaoCreditoProvider>
                )}

                <CardAppMobile>
                  <CardApp />
                </CardAppMobile>

                <CardIndicate />

                {Boolean( hasUmaAssinatura ) &&
                  !hasDuasAssinaturas &&
                  cardSegundaAssinatura()}
              </LeftContent>

              <RightContent>
                {hasAssinaturasAtivas ? (
                  <H1 id="opcional">
                    Para a turma do &apos;&apos;QUERO MAIS&apos;&apos;
                  </H1>
                ) : <RightContentTitleSpacement />}

                {Boolean( hasAssinaturasAtivas ) && (
                  <OpcionaisWrapper>
                    <CardOpcionais />
                  </OpcionaisWrapper>
                )}

                <CardAppDesktop>
                  <CardApp />
                </CardAppDesktop>

                {Boolean( assinaturaCuradoriaPresente ) && (
                  <CardPresenteado
                    idModalidadePermanecer={ MODALIDADE_CURADORIA.id }
                  />
                )}

                {Boolean( assinaturaIneditosPresente ) && (
                  <CardPresenteado
                    idModalidadePermanecer={ MODALIDADE_INEDITOS.id }
                  />
                )}
              </RightContent>
            </OpcionaisProvider>
          </ConteudoWrapper>
        ) )}

    </>
  )
}

export default Home
